import styled from 'styled-components';

export const Wrapper = styled.div<{
  isDisabled?: boolean;
  gap?: string;
}>`
  display: flex;
  row-gap: ${(props) => props.gap};
  column-gap: ${(props) => props.gap};
  align-items: center;

  > cc-icon {
    color: ${(props) => (props.isDisabled ? '#8090bb' : '#283044')};
  }

  > p {
    color: ${(props) => (props.isDisabled ? '#8090bb' : '#161d1f')};
    white-space: nowrap;
  }

  > span {
    color: ${(props) => (props.isDisabled ? '#8090bb' : '#161d1f')};
  }
`;
